export default __webpack_public_path__ + "static/media/flyback_controller_dc_ssr.55ec85aa.svg";